// extracted by mini-css-extract-plugin
export default {"container":"Buttons_container__nOxXo","title":"Buttons_title__dEsfx","text":"Buttons_text__X4SqJ","storeLink":"Buttons_storeLink__waOOa","storeImage":"Buttons_storeImage__m-HHi"};